/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_No_Folder_Selected_ToastInputs */

const en_image_export_no_folder_selected_toast = /** @type {(inputs: Image_Export_No_Folder_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select an export folder`)
};

const fr_image_export_no_folder_selected_toast = /** @type {(inputs: Image_Export_No_Folder_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un dossier d'exportation`)
};

const de_image_export_no_folder_selected_toast = /** @type {(inputs: Image_Export_No_Folder_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie einen Exportordner aus.`)
};

const it_image_export_no_folder_selected_toast = /** @type {(inputs: Image_Export_No_Folder_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una cartella di esportazione`)
};

const ru_image_export_no_folder_selected_toast = /** @type {(inputs: Image_Export_No_Folder_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите папку для экспорта.`)
};

const es_image_export_no_folder_selected_toast = /** @type {(inputs: Image_Export_No_Folder_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una carpeta de exportación`)
};

const zh_cn2_image_export_no_folder_selected_toast = /** @type {(inputs: Image_Export_No_Folder_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择导出文件夹`)
};

const ja_image_export_no_folder_selected_toast = /** @type {(inputs: Image_Export_No_Folder_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートフォルダを選択してください`)
};

const hi_image_export_no_folder_selected_toast = /** @type {(inputs: Image_Export_No_Folder_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया निर्यात फ़ोल्डर चुनें`)
};

const pt_pt2_image_export_no_folder_selected_toast = /** @type {(inputs: Image_Export_No_Folder_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione uma pasta de exportação.`)
};

/**
* | output |
* | --- |
* | "Please select an export folder" |
*
* @param {Image_Export_No_Folder_Selected_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_no_folder_selected_toast = /** @type {((inputs?: Image_Export_No_Folder_Selected_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_No_Folder_Selected_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_no_folder_selected_toast(inputs)
	if (locale === "de") return de_image_export_no_folder_selected_toast(inputs)
	if (locale === "it") return it_image_export_no_folder_selected_toast(inputs)
	if (locale === "ru") return ru_image_export_no_folder_selected_toast(inputs)
	if (locale === "es") return es_image_export_no_folder_selected_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_no_folder_selected_toast(inputs)
	if (locale === "ja") return ja_image_export_no_folder_selected_toast(inputs)
	if (locale === "hi") return hi_image_export_no_folder_selected_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_no_folder_selected_toast(inputs)
	return en_image_export_no_folder_selected_toast(inputs)
});